// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"Login_widgetContainer__2TVsG","wrapperContainer":"Login_wrapperContainer__1aKS7"};